import {
    SCREENAPP_LOADING,
    SCREENAPP_LOADED,
    SCREENAPP_SEARCHED,
    SCREENAPP_CREATED,
    SCREENAPP_DELETED,
    SCREENAPP_EDIT,
    SCREENAPP_DETAILS,
    SCREENAPP_FAILED,
    SCREEN_LOADING,
    SCREEN_LOADED,
    SCREEN_CREATED,
    SCREEN_MULTIPLE_CREATED,
    SCREEN_EDITED,
    SCREEN_DELETED,
    SCREEN_FAILED,
    SCREENITEM_LOADING,
    SCREENITEM_LOADED,
    SCREENITEM_CREATED,
    SCREENITEM_MULTIPLE_CREATETD,
    SCREENITEM_EDITED,
    SCREENITEM_DELETED,
    SCREENITEM_FAILED,
    LOGOUT,
} from '../types';

import { createPaginated } from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    appLoading: false,
    itemLoading: false,
    screenLoading: false,
    searchResults: null,
    success: false,
    allApps: null,
    app: null,
};

export default function(state = initialState, action) {
    let obj;
    switch (action.type) {
        case SCREENAPP_LOADING:
            return {
                ...state,
                success: false,
                appLoading: true,
            };
        case SCREEN_LOADING:
            return {
                ...state,
                success: false,
                screenLoading: true,
            };
        case SCREENITEM_LOADING:
            return {
                ...state,
                success: false,
                itemLoading: false,
            };
        case SCREENAPP_LOADED:
            return {
                ...state,
                success: false,
                appLoading: false,
                app: obj,
                allApps: action.payload,
            };
        case SCREENAPP_SEARCHED:
            return {
                ...state,
                success: false,
                appLoading: false,
                searchResults: action.payload,
            };
        case SCREENAPP_CREATED:
            return {
                ...state,
                success: true,
                appLoading: false,
                app: action.payload,
                allApps: createPaginated(state.allApps, action.payload),
            };
        case SCREENAPP_EDIT:
            obj = state.allApps ? {...state.allApps } : { result: [] };
            obj['result'] = obj.result.filter(
                (r) => r.appid !== action.payload.appid
            );
            obj['result'].unshift(action.payload);
            return {
                ...state,
                appLoading: false,
                success: action.continueEdit,
                app: action.continueEdit ? action.payload : null,
                allApps: obj,
            };

        case SCREENAPP_DELETED:
            obj = state.allApps ? {...state.allApps } : { result: [] };
            obj['result'] = obj.result.filter((r) => r.appid !== action.payload);
            return {
                ...state,
                success: false,
                appLoading: false,
                allApps: obj,
            };
        case SCREENAPP_DETAILS:
            return {
                ...state,
                success: false,
                appLoading: false,
                app: action.payload,
            };
        case SCREEN_LOADED:
            return {
                ...state,
                success: false,
                app: action.payload,
                screenLoading: false,
            };
        case SCREEN_CREATED:
            return {
                ...state,
                success: true,
                screenLoading: false,
                app: action.payload,
            };
        case SCREEN_MULTIPLE_CREATED:
            return {
                ...state,
                success: true,
                screenLoading: false,
                app: action.payload,
            };
        case SCREEN_EDITED:
            return {
                ...state,
                success: true,
                screenLoading: false,
                app: action.payload,
            };
        case SCREEN_DELETED:
            return {
                ...state,
                success: true,
                screenLoading: false,
                app: action.payload,
            };
        case SCREENITEM_MULTIPLE_CREATETD:
            return {
                ...state,
                success: true,
                itemLoading: false,
                app: action.payload,
            };
        case SCREENITEM_LOADED:
            return {
                ...state,
                success: false,
                itemLoading: false,
                app: action.payload,
            };
        case SCREENITEM_CREATED:
            return {
                ...state,
                success: true,
                itemLoading: false,
                app: action.payload,
            };
        case SCREENITEM_EDITED:
            return {
                ...state,
                success: true,
                itemLoading: false,
                app: action.payload,
            };
        case SCREENITEM_DELETED:
            return {
                ...state,
                success: true,
                itemLoading: false,
                app: action.payload,
            };
        case SCREENAPP_FAILED:
            return {
                ...state,
                success: false,
                appLoading: false,
            };
        case SCREEN_FAILED:
            return {
                ...state,
                success: false,
                screenLoading: false,
            };
        case SCREENITEM_FAILED:
            return {
                ...state,
                success: false,
                itemLoading: false,
            };
        case LOGOUT:
            return {
                loading: false,
                appLoading: false,
                itemLoading: false,
                screenLoading: false,
                searchResults: null,
                success: false,
                allApps: null,
                app: null,
            };
        default:
            return state;
    }
}